var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7461 0C9.0921 0 4.49219 4.5999 4.49219 10.2539C4.49219 12.7414 5.38253 15.0249 6.86129 16.8023L0.288385 23.3306C-0.0942814 23.7106 -0.096381 24.329 0.283648 24.7116C0.474566 24.9038 0.725543 25 0.976568 25C1.22535 25 1.47422 24.9055 1.6647 24.7163L8.24659 18.1792C10.017 19.6337 12.2814 20.5078 14.7461 20.5078C16.5052 20.5078 18.241 20.0545 19.7658 19.197C20.2359 18.9326 20.4027 18.3372 20.1383 17.8671C19.8739 17.397 19.2785 17.2302 18.8084 17.4946C17.5753 18.1881 16.1706 18.5547 14.7461 18.5547C10.169 18.5547 6.44532 14.831 6.44532 10.2539C6.44532 5.67686 10.169 1.95312 14.7461 1.95312C19.3232 1.95312 23.0469 5.67686 23.0469 10.2539C23.0469 11.6958 22.6717 13.1157 21.9621 14.3599C21.6948 14.8284 21.858 15.4248 22.3265 15.692C22.795 15.9592 23.3914 15.7961 23.6586 15.3276C24.5361 13.7891 25 12.0346 25 10.2539C25 4.5999 20.4001 0 14.7461 0Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/question-icon.ff653b7a0e396656de02da32c92d3ea7.svg";
export { ForwardRef as ReactComponent };